
riot.tag2('showhtml', '', '', 'style="width: 100%;"', function(opts) {
'use strict';

var self = this;

self.root.innerHTML = opts.value;
self.on('update', function () {
    self.unmount(true);
    self.mount();
});
});


// WEBPACK FOOTER //
// ./pages/settings/email/showhtml.tag